import {Injectable} from '@angular/core';

import {Observable} from 'rxjs';
import {HttpClient, HttpParams} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {Helper} from '../../helpers/helper.service';
import { catchError } from 'rxjs/operators';

@Injectable()
export class LocalizationService {
    public constructor(private http: HttpClient, private helper: Helper) {
    }
    getAllLocalization(params = new HttpParams()): Observable<any> {
        return this.http.get(environment.apiUrl + '/localization/status', {params: params})
            .pipe(catchError(res => this.helper.handleError(res)));
    }

  getServerDate(params = new HttpParams()): Observable<any> {
    return this.http.get(environment.apiUrl + '/localization/server-date', {params: params})
      .pipe(catchError(res => this.helper.handleError(res)));
  }
}
